import { agentClientToolCatalog, agentToolCatalog } from "../../autogen/agentToolCatalog";
import type { ToolResult } from "./tools";
import { catalogToToolSchemas, type ToolSchema } from "./toolSchema";

export const TOOL_MODULE_NOT_INCLUDED = "zz_AgentApiErrorCode_ToolModuleNotIncluded";

export const TOOL_MODULE_NOT_INCLUDED_MESSAGE = "Organisasjonen din har ikke tilgang til denne funksjonen i assistenten.";

export const toolModuleNotIncluded: ToolResult = {
  ok: false,
  deviationCode: TOOL_MODULE_NOT_INCLUDED,
  message: TOOL_MODULE_NOT_INCLUDED_MESSAGE,
};

export const documentSearchNotIncluded: ToolResult = {
  ok: false,
  deviationCode: TOOL_MODULE_NOT_INCLUDED,
  message:
    "Organisasjonen din har ikke dokumentsøk i assistenten. Det gjelder alle søk i dokumenter, med alle scope, " +
    "også på siden til en bestemt anskaffelse eller kontrakt. Si at organisasjonen ikke har dokumentsøk, og ikke " +
    "foreslå å åpne en anskaffelse, en kontrakt eller en annen side for å søke der.",
};

export const allTools: { name: string; module: string }[] = [
  ...agentToolCatalog.map((tool) => ({ name: tool.toolName, module: tool.module })),
  ...agentClientToolCatalog.map((tool) => ({ name: tool.name, module: tool.module })),
];

export const allToolNames = allTools.map((tool) => tool.name);

export const enabledToolNames = (fromServer: readonly string[] | undefined): ReadonlySet<string> =>
  new Set(fromServer ?? allTools.filter((tool) => tool.module === "assistant").map((tool) => tool.name));

export const wireToolSchemas = (enabled: ReadonlySet<string>): ToolSchema[] =>
  [
    ...catalogToToolSchemas(agentToolCatalog),
    ...agentClientToolCatalog.map(({ name, description, parameters }) => ({ name, description, parameters })),
  ].filter((tool) => enabled.has(tool.name));
